import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LanguageConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getNativeLanguage(): string | undefined {
		return this.service.get((x) => x.commonUi.language?.nativeLanguageRegex, undefined);
	}
}
